export const branding = {
  tenantId: 'american-dental',
  name: 'American Dental',
  tagline: 'Odontología con historia clínica dictada',
  primaryColor: '#0A3D62',
  secondaryColor: '#1E88E5',
  city: 'Quito',
};

const PRODUCT_HOSTS = new Set(['vyedocs', 'vyendelo', 'admin', 'auth', 'www', 'kong']);

/** Alias del host (trauma-quito.vyecom.com → trauma-quito). En local usa american-dental. */
export function clinicTenantId(): string {
  if (typeof location === 'undefined') return branding.tenantId;
  const host = location.hostname.split(':')[0].toLowerCase();
  if (!host || host === 'localhost' || host === '127.0.0.1') return branding.tenantId;
  const alias = host.replace(/\.apps\.vyecom\.com$/, '').replace(/\.vyecom\.com$/, '');
  if (!alias || PRODUCT_HOSTS.has(alias) || alias === host) return branding.tenantId;
  return alias;
}

export const auth = {
  url: 'https://auth.vyecom.com',
  realm: 'vyecom',
  clientId: 'vyedocs-shell',
  requireLogin: false,
};

/**
 * Mismos paths en local y prod.
 * Local: Vite proxea a 4201/4202 (producto).
 * Prod: nginx proxea /mf/dictation y /mf/documents a vyedocs;
 * /mf/vyendelo al producto Vyendelo.
 */
export const remotes = {
  dictation: '/mf/dictation/remoteEntry.json',
  documents: '/mf/documents/remoteEntry.json',
  vyendelo: '/mf/vyendelo/remoteEntry.json',
};
